<template>
  <thead>
  <tr :style="`background-color : ${wsLIGHTCARD};`" >

    <template v-for="(header,i) in headersFiltered">
      <th  v-if="header.align !== 'd-none'"
           :key="i + 'header'"
           :class="header.align ? `text-${header.align}` : ''"
           :style="getColumnStyle(i , header)"
           class="pointer pa-0"
           @click="header.sort !== false ?  on.sort(header.value) : null"
      >
        <v-hover v-slot="{hover}">
          <v-sheet color="transparent" class="d-flex align-center fill-height"
                   :class="[
                       { 'px-5' : (!enableDrag || i > 1) && !(header.noPadding || header.padding)},
                       { 'pr-5' : (enableDrag && i === 1) && !(header.noPadding || header.padding)},
                       { 'justify-center' : header.align === 'center' }
                   ]"
                   :style="header.padding ? `padding : 0 ${header.padding}px` : ''"
          >
            <slot :name="`header.${header.value}`" :header="header">
              <span :style="`color : ${hover || sortOn(header.value) ? '' : '#7a7a7a' }`" style="transition: all 0.3s ease">{{  header.text  }}</span>
            </slot>
            <v-sheet v-if="header.sortable !== false" color="transparent" width="20">
              <v-fade-transition>
                <v-icon
                    v-if="hover || sortOn(header.value) "
                    :color="sortOn(header.value)  ? 'black' : '' "
                    :class="[{rotate : sortDesc() && sortOn(header.value) }]"
                    style="transform-origin: center;"
                    small>
                  mdi-arrow-up
                </v-icon>

              </v-fade-transition>
            </v-sheet>
          </v-sheet>
        </v-hover>



      </th>
    </template>




  </tr>
  </thead>
</template>

<script>
export default {
  name: "wsTableHeader",
  props : {
    props : {
      type : Object,
      default() { return { headers : [] } }
    },
    on : {
      type : Object,
    },
    enableDrag : {
      type : Boolean,
      default : false
    }
  },
  computed : {
    headersFiltered() {

      let headers = this.props.headers
      if ( headers.length === 0) {
        return []
      }
      // headers = headers.filter(el => el.align !== 'd-none')

      return headers

    }
  },
  methods : {
    getColumnStyle(i , header ) {
      let style = `border-color : ${this.wsBACKGROUND};`
      style += 'color : #666A6D; '
      if ( i === 0) {
        style += 'border-radius: 8px 0 0 0  !important;'
      }
      if ( i === this.props.headers.length -1) {
        style += 'border-radius: 0 8px 0 0  !important;'
      }

      if ( header.width ) {
        style += `width : ${header.width}px;`
      }

      if ( header.borderLeft ) {
        style += `border-left: 1px solid ${this.wsBACKGROUND} !important;`
      }

      if ( header.borderRight) {
        style += `border-right: 1px solid ${this.wsBACKGROUND} !important;`
      }

      return style
    },
    sortOn(header) {
      return this.props.options.sortBy.includes(header)
    },
    sortDesc() {
      return this.props.options.sortDesc[0]
    }
  }
}
</script>

<style scoped>
.rotate {
  transform: rotate(180deg);

}
</style>